import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCurrentTenant, updateTenantLogo } from "../services/tenantApi";

export function useUpdateCurrentTenant(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCurrentTenant,
    onSuccess: (data) => {
      if (extendedLog) console.log(data);
      console.log(`${data.name} has been saved successfully!`);
      queryClient.setQueryData(queryData, data);
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useUpdateTenantLogo(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateTenantLogo,
    onSuccess: (data) => {
      if (extendedLog) console.log(data);
      console.log("Tenant logo has been saved successfully!");
      queryClient.setQueryData(queryData, data);
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}
